import { Badge } from "@/components/ui/badge";

export const STATUS_STYLE = {
  hadir: "bg-emerald-100 text-emerald-800 border-emerald-200",
  izin: "bg-amber-100 text-amber-800 border-amber-200",
  sakit: "bg-blue-100 text-blue-800 border-blue-200",
  alpa: "bg-rose-100 text-rose-800 border-rose-200",
  ringan: "bg-yellow-100 text-yellow-800 border-yellow-300",
  sedang: "bg-orange-100 text-orange-800 border-orange-300",
  berat: "bg-red-100 text-red-800 border-red-300",
  aktif: "bg-emerald-100 text-emerald-800 border-emerald-300",
  khos: "bg-amber-100 text-amber-800 border-amber-300",
  boyong: "bg-rose-100 text-rose-800 border-rose-300",
  diboyong: "bg-slate-200 text-slate-600 border-slate-300",
  alumni: "bg-slate-200 text-slate-700 border-slate-300",
  nonaktif: "bg-zinc-200 text-zinc-600 border-zinc-300",
};

export function StatusBadge({ status }) {
  const s = (status || "").toLowerCase();
  return (
    <Badge className={`border capitalize font-medium ${STATUS_STYLE[s] || "bg-slate-100 text-slate-600 border-slate-200"}`}>
      {status}
    </Badge>
  );
}

export function PageHeader({ icon: Icon, title, subtitle }) {
  return (
    <div className="flex items-start gap-3">
      {Icon && <div className="h-11 w-11 rounded-2xl bg-emerald-100 dark:bg-emerald-900/40 text-emerald-700 dark:text-emerald-300 flex items-center justify-center shrink-0"><Icon className="h-5 w-5" /></div>}
      <div>
        <h2 className="text-xl sm:text-2xl font-bold text-emerald-900 dark:text-emerald-100 tracking-tight">{title}</h2>
        {subtitle && <p className="text-slate-500 dark:text-slate-400 text-sm">{subtitle}</p>}
      </div>
    </div>
  );
}

export function InfoNote({ children, label = "Lihat penjelasan" }) {
  return (
    <details className="glass rounded-xl px-3 py-2 text-xs text-slate-500 dark:text-slate-300" data-testid="info-note">
      <summary className="cursor-pointer select-none flex items-center gap-1.5 text-emerald-700 dark:text-emerald-300 font-medium list-none [&::-webkit-details-marker]:hidden">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><path d="M12 16v-4M12 8h.01" /></svg>
        {label}
      </summary>
      <div className="mt-2 leading-relaxed">{children}</div>
    </details>
  );
}

export function timeAgo(isoStr) {
  const d = new Date(isoStr);
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return "baru saja";
  if (diff < 3600) return `${Math.floor(diff / 60)} mnt lalu`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} jam lalu`;
  return d.toLocaleDateString("id-ID", { day: "numeric", month: "short" });
}

export function initials(name) {
  return (name || "?").split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase();
}

export function greeting() {
  const h = new Date().getHours();
  if (h < 11) return "Selamat pagi";
  if (h < 15) return "Selamat siang";
  if (h < 18) return "Selamat sore";
  return "Selamat malam";
}

export const KATEGORI_LABEL = { ngaji_dhuha: "Keaktifan Ngaji Dhuha", kegiatan_harian: "Kegiatan Harian" };

// Global consistent category colors used across all charts, bars, cards & legends.
export const CAT_COLORS = {
  ngaji:      { solid: "#4E8B1E", grad: ["#3B6D11", "#639922"] },
  departemen: { solid: "#2E7D5B", grad: ["#2E7D5B", "#4FB58A"] },
  ribath:     { solid: "#C08A0E", grad: ["#8A6A08", "#D4A72C"] },
  kuliah:     { solid: "#2E77AE", grad: ["#1F5F8B", "#4A9ED8"] },
};

export const LOGO_URL = "https://customer-assets-4nw71qhi.emergentagent.net/job_student-tracker-604/artifacts/i7e8yl3h_Logo%20Pondok%203D%20New.webp";
export const APP_NAME = "Sinar Santri";
export const APP_SUB = "Mamba'us Sholihin";
export const CALLIGRAPHY_URL = "https://static.prod-images.emergentagent.com/jobs/8012f3a6-2f27-4595-9623-c4c0fca1de31/images/7fc580affe0c0eb6e8fd100285ae5c2fe282fbed7bc4cbf835e6e6ab873e3e5f.jpeg";

export const PERIODS = [
  { v: "week", label: "Minggu Ini" },
  { v: "month", label: "Bulan Ini" },
  { v: "all", label: "Semua" },
];

export function periodRange(p) {
  const now = new Date();
  if (p === "week") {
    const d = new Date(now);
    d.setDate(now.getDate() - 6);
    return { start: d.toISOString().slice(0, 10), end: now.toISOString().slice(0, 10) };
  }
  if (p === "month") {
    const d = new Date(now.getFullYear(), now.getMonth(), 1);
    return { start: d.toISOString().slice(0, 10), end: now.toISOString().slice(0, 10) };
  }
  if (/^\d{4}-\d{2}$/.test(p)) {
    const [y, m] = p.split("-").map(Number);
    const last = new Date(y, m, 0).getDate();
    return { start: `${p}-01`, end: `${p}-${String(last).padStart(2, "0")}` };
  }
  return {};
}
